import { lazy } from 'react';

const SurveyDetailsModal = lazy(
  () => import('modules/StudentDashboard/modals/SurveyDetailsModal'),
);

export default {
  SURVEY_DETAILS_MODAL: SurveyDetailsModal,
};
